import {
  type DualResumeStores,
  type ResumeSelector,
  resumeCandidates,
  selectResume,
} from "../../../shared/lib/DualResume/useDualResumeObjectsRead";
import type { ViewJobResumeFieldsFragment } from "./__generated__/jobSeekerProfile.gqlgenerated";

/**
 * The account's main resume — its Indeed Resume, or its upload when that is all it has.
 *
 * The legacy field returns an upload-only account's PARSED record, so those accounts see their
 * resume location today. Selecting INDEED_RESUME alone would drop them to the contact-info
 * fallback.
 */
const VIEWJOB_RESUME_TARGET: ResumeSelector = {
  resumeTypeWithFallback: ["INDEED_RESUME", "PARSED"],
};

/**
 * The resume viewjob reads and writes, from whichever store the gate selected.
 *
 * Both operations carrying resume data gate the two sources against the same variable, so this
 * is the one place that turns either shape into the single resume the commute section shows and
 * updates.
 */
export function selectViewJobResume(
  data: DualResumeStores<ViewJobResumeFieldsFragment> | null | undefined,
  useResumeCollection: boolean,
): ViewJobResumeFieldsFragment | undefined {
  return selectResume({
    candidates: resumeCandidates<ViewJobResumeFieldsFragment>(data, useResumeCollection),
    target: VIEWJOB_RESUME_TARGET,
  });
}
